import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import { $helpers } from 'vue-mapbox';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var geocoderEvents = {
  clear: 'clear',
  loading: 'loading',
  results: 'results',
  result: 'result',
  error: 'error'
};
var GeocoderControl = {
  name: 'GeocoderControl',
  mixins: [$helpers.asControl],
  inject: ['mapbox', 'map'],
  props: {
    position: {
      type: String,
      default: 'top-right'
    },
    container: {
      type: String,
      default: null
    },
    // Mapbox-geocoder options
    accessToken: {
      type: String,
      required: true
    },
    proximity: {
      type: Object,
      default: null
    },
    // Component options
    input: {
      type: String,
      default: null
    },
    mapboxgl: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      initial: true
    };
  },
  watch: {
    input: {
      handler: function handler(next, prev) {
        if (this.control && next !== prev) {
          this.control.setInput(next);
        }
      },
      immediate: true
    },
    proximity: function proximity(next, prev) {
      if (this.control && next !== prev) {
        this.control.setProximity(next);
      }
    }
  },
  created: function created() {
    this.control = null;

    if (this.accessToken && !this.mapbox.accessToken) {
      this.mapbox.accessToken = this.accessToken;
    }

    this.control = new MapboxGeocoder(_objectSpread2(_objectSpread2({}, this.$attrs), {}, {
      proximity: this.proximity,
      accessToken: this.accessToken
    }));
    this.control.on('results', this.$_updateInput);
    this.$_deferredMount();
  },
  beforeDestroy: function beforeDestroy() {
    this.control.off('results', this.$_updateInput);
  },
  methods: {
    $_deferredMount: function $_deferredMount() {
      if (this.container !== null) {
        document.getElementById(this.container).appendChild(this.control.onAdd(this.map));
      } else {
        this.map.addControl(this.control, this.position);
      }

      if (this.input) {
        this.control.setInput(this.input);
      }

      this.$_emitEvent('added', {
        geocoder: this.control
      });
      this.$_bindSelfEvents(Object.keys(geocoderEvents));
      this.initial = false;
    },
    $_bindSelfEvents: function $_bindSelfEvents(events) {
      var _this = this;

      var vm = this;
      Object.keys(this.$listeners).forEach(function (eventName) {
        if (events.includes(eventName)) {
          _this.control.on(eventName, vm.$_emitControlEvent.bind(vm, eventName));
        }
      });
    },
    $_emitControlEvent: function $_emitControlEvent(eventName, eventData) {
      return this.$_emitSelfEvent({
        type: eventName
      }, eventData);
    },
    $_updateInput: function $_updateInput(results) {
      if (!this.initial) {
        var input = results.query ? results.query.join(' ') : ' ';
        this.$emit('update:input', input);
      }
    },
    query: function query(_query) {
      if (this.control) {
        this.$emit('update:input', _query);
        return this.control.query(_query);
      }

      return null;
    }
  }
};

export default GeocoderControl;
